import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/10/thumb-landscape.jpg"

const Post10 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">CELINE／クラシックボックス／24 x19 x5cm</span>   
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          皆さんはCELINE（セリーヌ）といえば何を思い浮かべますか？<br></br>「海外セレブや有名人がこぞって愛用してる」<br></br>「オシャレな人は大体持ってる」<br></br>「インスタで人気」<br></br>セリーヌの特徴でもある「ミニマルなファッション」はその人のスタイルを生かし、より洗練された印象に変えてくれるのが魅力です。そこで今回は、シンプルかつエレガントに大人の女性を彩ってくれる「セリーヌ」の人気バッグ10選をご紹介します！
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ラゲージ（Luggage）</h2>
          <p>CELINEといえば「ラゲージ」ですよね。絶大的な人気を誇るラゲージは、シンプルでミニマルながらも一度見たら忘れないユニークでセンスの光るデザインが特徴です。持つだけで、コーデを洗練されたスタイルに変えてくれます。ナノ・マイクロ・ミニショッパー・ファントムと４サイズ展開されており、ライフスタイルに寄り添ってくれるのも魅力です。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/10/1.jpg" alt="" />
        </figure>
        <span className="text-center">CELINE／マイクロショッパー／26 x25 x12cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/2.jpg" alt="" />
            <span className="text-center">CELINE／マイクロショッパー／26 x25 x12cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/3.jpg" alt="" />
            <span className="text-center">CELINE／ナノショッパー／20 x18 x9cm</span> 
          </figure>          
        </div>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/4.jpg" alt="" />
            <span className="text-center">CELINE／マイクロショッパー／26 x25 x12cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/5.jpg" alt="" />
            <span className="text-center">CELINE／ファントム／30 x26 x23cm</span> 
          </figure>          
        </div> 
        <div className="text-max-width">
          <h2>トリオ（Trio）</h2>
          <p>名前の通り３つのポーチが繋がったデザインが特徴の「トリオ」。スナップボタンで取り外しが可能で、３つのポーチを２つにしたり、様々な組み合わせができるミニマル派の強い味方です。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/6.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/7.jpg" alt="" />
          </figure>          
        </div>    
        <span className="text-center">CELINE／トリオ／20 x14 x3cm</span>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/8.jpg" alt="" />
            <span className="text-center">CELINE／トリオ／20 x14 x3cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/9.jpg" alt="" />
            <span className="text-center">CELINE／トリオ／20 x15 x3cm</span> 
          </figure>
        </div>  
        <div className="text-max-width">
        <h2>トリフォルド（Tri Fold）</h2>
        <p>セリーヌらしい美しく構築的なデザインが際立つ「トリフォルド」。エレガントな見た目ながら、A4サイズの書類も入れることができる大容量の収納力。中央部分にはジップもついており、貴重品なども安全に持ち運ぶことができ、お仕事バッグとしても人気の高いアイテム。</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/10.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/11.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">CELINE／トリフォルドスモール／31 x22 x13cm</span>           
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/12.jpg" alt="" />
            <span className="text-center">CELINE／トリフォルドミディアム／37 x25 x10cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/13.jpg" alt="" />
            <span className="text-center">CELINE／トリフォルドクラッチ／28 x19 x7cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
          セリーヌのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>カバファントム（Cabas Phantom）</h2>
          <p>仕事にもプライベートにも使えるのが魅力の「カバファントム」は、収納力抜群の一品です。他にもカバシリーズには、トートタイプやバイカラーになっているものなど種類が豊富です！ミニマル派のインスタグラマーにも大人気♡</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/14.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/15.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">CELINE／カバファントム／28 x35 x18cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/16.jpg" alt="" />
            <span className="text-center">CELINE／カバファントム／28-40cm x 35cm x 20cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/17.jpg" alt="" />
            <span className="text-center">CELINE／カバファントム／28 x30 x17cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
        <h2>セーズ（16）</h2>
        <p>セリーヌのイメージ・ディレクターHedi Slimane (エディ・スリマン)が就任初日にデザインした初めてのハンドバッグ「16 (セーズ)」。柔らかなソフトカーフレザーと丸みを帯びたシルエットが特徴的で、60年代を彷彿とさせるクラシックなデザイン。海外セレブの愛用者が多いことでも有名です。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/18.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/19.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">CELINE／16セーズスモール／22 x18 x10cm</span>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/20.jpg" alt="" />
            <span className="text-center">CELINE／16セーズスモール／21 x18 x7cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/21.jpg" alt="" />
            <span className="text-center">CELINE／16セーズブザス／19 x17 x8cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ベルトバッグ（Belt Bag）</h2>
          <p>上品でシャープなフォルムに、２つに伸びたカジュアルなベルトが調和し、きちんと感と抜け感を融合した「ベルトバッグ」。フォーマルからカジュアルまで、どんなスタイル、シチュエーションにも合わせられるのが魅力です。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/22.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/23.jpg" alt="" />
          </figure>
        </div>    
        <span className="text-center">CELINE／ベルトバッグミニ／28 x22 x17cm</span>          
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/24.jpg" alt="" />
            <span className="text-center">CELINE／ベルトバッグナノ／20 x17 x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/25.jpg" alt="" />
            <span className="text-center">CELINE／ベルトバッグナノ／20 x16 x10cm</span> 
          </figure>
        </div> 
        <div className="text-max-width">
          <h2>バーティカルカバ（Vertical Cabas）</h2>
          <p>インスタでも話題沸騰中の「バーティカルカバ」。シンプルなスクエアフォルムに大きなロゴのバランス感がこなれた印象を演出。特に「スモールバーティカルカバ」は、スマホ・財布など最小限の荷物を入れてお出かけできる今っぽいミニマム感が人気です。</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/26.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/27.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">CELINE／バーティカルカバ／37 x38 x8cm</span>               
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/28.jpg" alt="" />
            <span className="text-center">CELINE／スモールバーティカルカバ／28 x32 x8cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/29.jpg" alt="" />
            <span className="text-center">CELINE／スモールバーティカルカバ／28 x31 x8cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
          セリーヌのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>トリオンフ（Triomphe）</h2>
          <p>「トリオンフ」とは、パリ・凱旋門(がいせんもん)の鎖をモチーフにしたアイテムのこと。クラシカルなゴールドパーツを使用しているものや、全面にトリオンフロゴが刺繍されたタイプなど、どれも高級感のある逸品。カラーや型のモデルも豊富なので、ぜひチェックしてみて。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/30.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/31.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">CELINE／チェーンクラッチ／16 x11 x9cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/32.jpg" alt="" />
            <span className="text-center">CELINE／チェーンクラッチ／15 x10 x8cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/33.jpg" alt="" />
            <span className="text-center">CELINE／トリオンフミディアム／22 x15 x6cm</span> 
          </figure>       
        </div>
        <div className="text-max-width">
          <h2>ビッグバッグスモール（Big Bag Small）</h2>
          <p>高級レザー「ソフトベアカーフスキン」と内側のスエード素材のコンビネーションが、持つだけで上品な雰囲気を演出してくれる「ビッグバッグスモール」。マチの広いデザインで収納力が高く、ミディアムやラージであれば、A4サイズの資料やノートPCなども余裕を持って入れられるので通勤バッグとしても大人気のアイテム。</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/34.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/35.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">CELINE／ビッグバッグスモール／24 x25 x22cm</span>          
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/36.jpg" alt="" />
            <span className="text-center">CELINE／ビッグバッグスモール／23 x26 x21cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/37.jpg" alt="" />
            <span className="text-center">CELINE／ビッグバッグバケットナノ／15 x21 x15cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>クラシック（Classic）</h2>
          <p>シンプルでかっちりとした見た目がかっこいい「クラシック」はオンオフ問わず使える優れもの。また、ショルダーを取り外せばクラッチとしても使えるのでパーティーシーンでも活躍。上質な大人のオシャレを楽しむことができます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/38.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/39.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">CELINE／クラシックボックス／22 x18 x6cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/40.jpg" alt="" />
            <span className="text-center">CELINE／クラシックボックス／24 x19 x5cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/10/41.jpg" alt="" />
            <span className="text-center">CELINE／クラシック／23 x20 x6cm</span> 
          </figure>
        </div>                            
        <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
          セリーヌのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post10

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 10}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
